import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import tokens from '../theme/tokens';

// '기타'를 1개 이상 고르면 아래에 나타나는 물품 설명 칸 — 입력창(.textBox)과 같은 틀.
// 값은 요청사항과 별개의 키(etcDesc)로 서버에 가고, 인성 메모에만 덧붙는다(고객 화면의 요청사항에는 보이지 않는다).
const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginTop: 12,
    animation: '$drop .18s ease-out',
  },
  '@keyframes drop': {
    from: { opacity: 0, transform: 'translateY(-4px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minHeight: tokens.rowHeight,
    padding: '0 16px',
    borderRadius: tokens.radius,
    border: `1px solid ${tokens.line}`,
    backgroundColor: tokens.surface,
    transition: 'border-color .12s, box-shadow .12s',
    '&:focus-within': { borderColor: tokens.primary, boxShadow: tokens.shadow },
  },
  tag: {
    flex: 'none',
    marginRight: 10,
    padding: '3px 8px',
    borderRadius: 10,
    backgroundColor: tokens.primarySoft,
    color: tokens.primaryDark,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: -0.4,
  },
  input: {
    flex: '1 1 auto',
    minWidth: 0,
    height: 48,
    border: 'none',
    outline: 'none',
    fontSize: 15,
    fontFamily: 'inherit',
    color: tokens.ink,
    backgroundColor: 'transparent',
    '&::placeholder': { color: tokens.placeholder },
  },
  count: {
    flex: 'none',
    marginLeft: 8,
    fontSize: 12,
    color: tokens.muted,
  },
  dense: {
    '& $field': { padding: '0 12px' },
    '& $input': { fontSize: 14 },
  },
}));

const MAX = 100;

function StuffEtcInput({ value = '', onChange, dense = false, placeholder = '어떤 물건인지 적어 주세요 (예: 화분 2개, 원단 1롤)' }) {
  const cs = useStyles();
  return (
    <div className={clsx(cs.root, dense && cs.dense)}>
      <div className={cs.field}>
        <span className={cs.tag}>기타</span>
        <input
          className={cs.input}
          type="text"
          maxLength={MAX}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          aria-label="기타 물품 설명"
        />
        <span className={cs.count}>{value.length}/{MAX}</span>
      </div>
    </div>
  );
}

export default StuffEtcInput;
